<template>
  <div class="consumption-details-modal">
    <CustomModal
      :visible="showModal"
      title="Mein Modal"
      :showPrev="false"
      :showNext="true"
      prevText="Zurück"
      nextText="Weiter"
      @close="hideModal"
      @next="hideModal"
    >
      <template #header>
        Zusammensetzung
      </template>
      <template>
        <div class="consumption-details" v-if="consumptionDetails">
          <div v-for="t in sortedTariffsOrOptions" :key="t.id">
            <div class="text-base">{{ t.name }}</div>
            <div class="text-base">
              {{ formatNumber(t.consumptions[0].consumed) }}
              <Unit :unit="consumptionDetails.unit"></Unit> von
              {{ formatNumber(t.consumptions[0].max) }}
              <Unit :unit="t.consumptions[0].unit"></Unit> verbraucht
            </div>
            <div class="text-base">Gültig bis: {{ formatDate(t.consumptions[0].expirationDate) }}</div>
          </div>
          <hr />
          <div>
            <div class="details-summary text-base-semibold">
              <span>Gesamt</span>
              <span>{{ formatNumber(consumptionDetails.max) }} <Unit :unit="consumptionDetails.unit"></Unit></span>
            </div>
            <div class="text-base">
              <slot name="popoverConsumed"
                >{{ formatNumber(consumptionDetails.consumed) }} <Unit :unit="consumptionDetails.unit"></Unit> von
                {{ formatNumber(consumptionDetails.max) }}
                <Unit :unit="consumptionDetails.unit"></Unit> verbraucht</slot
              >
            </div>
          </div>
        </div>
      </template>
      <template #btnNextTxt>Schließen</template>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from '@/components/generic/CustomModal.vue'
import Unit from './Unit.vue'

export default {
  components: { CustomModal, Unit },
  props: {
    consumptionDetails: {
      type: Object,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortedTariffsOrOptions() {
      const toSort = this.consumptionDetails.tariffOrOptions
      return toSort.sort((a, b) => {
        if (a.type !== b.type) {
          if (a.type === 'Tariff') {
            return -1
          }
          return 1
        }
        return 0
      })
    }
  },
  methods: {
    hideModal() {
      this.$emit('close')
    },
    formatDate(date) {
      if (this.$config?.calendar?.formatter?.dateFormatter === null) {
        return '-'
      }
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    },
    formatNumber(number) {
      if (this.$config?.calendar?.formatter?.numberFormatter === null) {
        return '-'
      }
      return this.$config.calendar.formatter.numberFormatter.format(number)
    }
  }
}
</script>
